// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__tYwE4","open":"Menu_open__+N4aj"};